module.exports = __webpack_public_path__ + "img/option_on_main_icon.19ef10b2.png";